export const NotificationTimeout = 3000;
export const MaxNbOfNotifications = 6;
